/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-30 18:57:40
 */

import StationConfig from '../stationConfig';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import StationConfigApi, { StationConfigDOI } from '../api/stationConfigApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import AreaCascader from 'src/components/areaCascader/areaCascader';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumStationType from 'src/enums/enumStationType';
import Input from 'src/types/iview/Input';
import EnumEntity from 'src/enums/enumEntity';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import alertStationOperateModal from '../stationOperateModal';
import EnumOperates from 'src/enums/enumOperates';

export default class StationConfigService extends ListPageService {
    ctx: StationConfig;
    type: any;

    constructor(ctx: StationConfig) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '',
                field: 'sort',
                width: 50,
                rowDrag: true,
                suppressMovable: true,
                cellRenderer(params) {
                    if (params.value == null) return '';
                    return params.value;
                },
            },
            {
                headerName: '站点名称',
                field: 'name',
                minWidth: 80,
            },
            {
                headerName: 'MN号',
                field: 'mn',
                minWidth: 100,
            },
            {
                headerName: '站点类型',
                field: 'type',
                minWidth: 100,
                cellRenderer(params) {
                    let data: StationConfigDOI.RowDataI = params.data;
                    return EnumStationType.findId(data.type).getName();
                },
            },
            {
                headerName: '所属区域',
                field: 'idNumber',
                minWidth: 190,
                cellRenderer(params) {
                    let data: StationConfigDOI.RowDataI = params.data;
                    return data.province_name + data.city_name + data.district_name;
                },
            },
            {
                headerName: '所属流域',
                field: 'basin',
                minWidth: 140,
            },
            {
                headerName: '通讯协议',
                field: 'agreement_name',
                minWidth: 140,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 140,
                cellRenderer(params) {
                    let data: StationConfigDOI.RowDataI = params.data;
                    if (data.status == 0) {
                        return "正常"
                    }
                    else{
                        return "删除"
                    }
                },
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: StationConfigDOI.RowDataI = params.data;
                            let res = await alertStationOperateModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: StationConfigDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                ],
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertStationOperateModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            },
            // {
            //     text: '删除',
            //     type: 'info',
            //     async onClick() {
            //         let gridOptions: any = t.ctx.gridOptions;
            //         let selectRows: StationConfigDOI.RowDataI[] = gridOptions.api.getSelectedRows();
            //         if (selectRows.length === 0) {
            //             return Toast.warning('请选择要操作的数据');
            //         }
            //         let res = await Toast.confirm();
            //         if (!res) {
            //             return;
            //         }
            //         let ids: number[] = selectRows.map(item => item.id);
            //         await t.delete(ids);
            //     },
            // },
        ];
    }
    async delete(ids: number[]) {
        let { code } = await StationConfigApi.delete({ device_ids: ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    async dragRow(event: any) {
        let ctx = this.ctx;
        let draggedId = event.node.data.id;
        let overId = event.overNode.data.id;
        let datas = ctx.rowData;
        const sortedData = [...datas].sort((a, b) => b.sort - a.sort);
        const dragIndex = sortedData.findIndex(item => item.id === draggedId);
        const targetIndex = sortedData.findIndex(item => item.id === overId);
        if (dragIndex === -1 || targetIndex === -1) return;
        const [dragItem] = sortedData.splice(dragIndex, 1);
        sortedData.splice(targetIndex, 0, dragItem);
        let nonNullItems = sortedData.filter(item => item.sort != null);
        if (nonNullItems.length === 0) return;
        let existingSorts = nonNullItems.map(i => i.sort).sort((a, b) => b - a);
        let sortData = nonNullItems.map((item, i) => ({
            id: item.id,
            sort: existingSorts[i],
        }));
        await StationConfigApi.sortBatch(sortData);
        this.searchTable();
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: CommonSelect,
                label: '站点类型',
                field: 'type',
                labelWidth: 60,
                width:160,
                props: { value: null, dataSource: EnumStationType.getList() },
            },
            {
                component: AreaCascader,
                label: '区域',
                field: 'area：',
                width: 300,
                labelWidth: 40,
                dealParam(value) {
                    return {
                        province_id: value[0],
                        city_id: value[1],
                        district_id: value[2],
                    };
                },
                props: { value: [], type: this.type },
            },
            {
                component: EntitySelect,
                label: '所属流域',
                field: 'basin_id',
                labelWidth: 60,
                width:160,
                props: { value: null, type: EnumEntity.Basin.getId() },
            },
            {
                component: EntitySelect,
                label: '通讯协议',
                field: 'agreement_id',
                labelWidth: 60,
                width:160,
                props: { value: null, type: EnumEntity.Agreement.getId() },
            },
            {
                component: Input,
                label: '',
                labelWidth: 20,
                field: 'name_mn',
                props: { value: '', placeholder: '请输入站点名称/mn号' },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<StationConfigDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await StationConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
